import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { PopUp } from "@/components/shared/PopUp";
import { WebsCta } from "./webs-cta/WebsCta";
import { Header } from "./header/Header";
import { Footer } from "./footer/Footer";

// styles
import "./index.scss";

interface LayoutProps {
  footerRedirections: boolean;
  headerTransition: boolean;
  children: React.ReactNode;
  footer: boolean;
  mainId?: string;
}

export const Layout: React.FC<LayoutProps> = ({
  footerRedirections,
  headerTransition,
  children,
  mainId,
  footer,
}) => {
  const data = useStaticQuery(graphql`
    query layoutQuery {
      wpLayoutElement(slug: { eq: "elements" }) {
        layout {
          callToAction {
            booking {
              innerRedirection
              innerText
            }
            webs {
              webUrl
              webImage {
                node {
                  publicUrl
                  altText
                  title
                }
              }
            }
            enterpriseLogo {
              node {
                publicUrl
                title
                altText
              }
            }
          }
          footerContent {
            firstSectionTitle
            firstSectionLinks {
              linkRedirection
              linkText
              linkType
            }
            secondSectionTitle
            secondSectionLinks {
              linkText
              linkRedirection
              linkType
            }
            socialMediaLinks {
              link
              name
              image {
                node {
                  publicUrl
                  altText
                  title
                }
              }
            }
          }
        }
      }
    }
  `);
  const { footerContent, callToAction } = data.wpLayoutElement.layout;
  return (
    <div id="page-wrapper" className="page-wrapper">
      <Header transition={headerTransition} callToAction={callToAction} />
      <main id={`${mainId}`}>{children}</main>
      {footer ? (
        <>
          <Footer content={footerContent} />
          {footerRedirections ? <WebsCta callToAction={callToAction} /> : ""}
        </>
      ) : (
        <></>
      )}
      <PopUp />
    </div>
  );
};
